import { render } from "./ProductListStock.vue?vue&type=template&id=6c01cddc"
import script from "./ProductListStock.vue?vue&type=script&lang=js"
export * from "./ProductListStock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__